interface ResetPassword {
	currentPassword?: string;
	newPassword?: string;
	newPasswordEmpty?: string;
	newPasswordLength?: string;
	newPasswordLower?: string;
	newPasswordUpper?: string;
	newPasswordNumber?: string;
	newPasswordSpecial?: string;
	newPasswordSame?: string;
	retryNewPassword?: string;
	retryNewPasswordEmpty?: string;
	retryNewPasswordMatch?: string;
}

class ResetPasswordError extends Error {
	resetPassword: ResetPassword = {};

	newPassword: ResetPassword = {};

	constructor({
		currentPassword,
		newPassword,
		retryNewPassword,
		newPasswordEmpty,
		newPasswordLength,
		newPasswordLower,
		newPasswordUpper,
		newPasswordNumber,
		newPasswordSpecial,
		newPasswordSame,
		retryNewPasswordEmpty,
		retryNewPasswordMatch
	}: ResetPassword) {
		super();

		this.resetPassword.currentPassword = currentPassword;
		this.resetPassword.newPassword = newPassword;
		this.resetPassword.retryNewPassword = retryNewPassword;
		this.resetPassword.newPasswordEmpty = newPasswordEmpty;
		this.resetPassword.newPasswordLength = newPasswordLength;
		this.resetPassword.newPasswordLower = newPasswordLower;
		this.resetPassword.newPasswordUpper = newPasswordUpper;
		this.resetPassword.newPasswordNumber = newPasswordNumber;
		this.resetPassword.newPasswordSpecial = newPasswordSpecial;
		this.resetPassword.newPasswordSame = newPasswordSame;
		this.resetPassword.retryNewPasswordEmpty = retryNewPasswordEmpty;
		this.resetPassword.retryNewPasswordMatch = retryNewPasswordMatch;
	}
}

export { ResetPassword, ResetPasswordError };
